export default "__VITE_ASSET__ClGORkjM__"